import { type FormikConfig } from 'formik'

import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { formatExternalPaymentMethodFormForSubmissionUseCase } from '@webapp/platform/banking/business-logic/use-cases/FormatExternalPaymentMethodFormForSubmissionUseCase'
import { type PaymentMethodConstructor } from '@webapp/platform/banking/entities/PaymentMethod'
import messages from './messages'
import { useMutateCreateExternalPaymentMethod } from '../../models/useMutateCreateExternalPaymentMethod'
import { type ExternalPaymentMethodFormSchema } from '../../views/ExternalPaymentMethodForm/ExternalPaymentMethodForm'

export const useCreateExternalPaymentMethodFormPresenter = ({
  vendorId,
  onSuccess,
}: {
  vendorId: number
  onSuccess?: (paymentMethod: PaymentMethodConstructor) => void
}) => {
  const intl = useProcurifyIntl()

  const { createExternalPaymentMethod } = useMutateCreateExternalPaymentMethod()

  const submitExternalPaymentMethodForm: FormikConfig<ExternalPaymentMethodFormSchema>['onSubmit'] =
    async (values, actions) => {
      try {
        const { data: paymentMethod } = await createExternalPaymentMethod(
          formatExternalPaymentMethodFormForSubmissionUseCase(vendorId, values)
        )

        toast.success({
          title: intl.formatMessage(messages.paymentMethodCreatedSuccessToast),
        })

        onSuccess?.(paymentMethod)
      } catch (e) {
        actions.setSubmitting(false)

        const errorMessage = getMessageFromError(e)

        toast.error({
          title: intl.formatMessage(messages.createPaymentMethodErrorToast),
          children: errorMessage,
        })
      }
    }

  return {
    commands: {
      submitExternalPaymentMethodForm,
    },
  }
}
